<template>
  <div :style="$cmsStyles('c_d00c9b792a4f')" class="media-container">
    <tools-bar ref="toolsBar"></tools-bar>
    <div class="media-content">
      <div class="service-wrapper">
        <div v-show="$cms('c_d00c9b792a4f', 'f_0001', true)" class="banner-wrapper">
          <h1 class="title">{{ $cms('c_d00c9b792a4f', 'f_0002', "全网70万中小主播分销网络") }}<br>{{ $cms('c_d00c9b792a4f', 'f_0003', "沉淀各品类爆款SKU商品库") }}</h1>
          <div class="desc">
            {{ $cms('c_d00c9b792a4f', 'f_0004', "为品牌打造全域增长新引擎") }}
          </div>
          <div class="actions">
            <div class="btn btn-white" @click="onJoinClick(2)">{{ $cms('c_d00c9b792a4f', 'f_0005', "商家合作") }}</div>
          </div>
        </div>
        <div class="content-wrapper">
          <div v-show="$cms('c_d00c9b792a4f', 'f_0006', true)" class="box-1">
            <div class="box-header">
              <h2 class="box-header-title">{{ $cms('c_d00c9b792a4f', 'f_0007', "你是否正在经历以下难题？") }}</h2>
            </div>
            <div class="box-content">
              <div class="item">
                <div class="item-header">
                  <!-- <img class="item-header-icon" src="https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250731171108670000660.17539530684145417.jpg" alt=""> -->
                  <div class="item-header-title">{{ $cms('c_d00c9b792a4f', 'f_0008', "达人带货") }}</div>
                </div>
                <div class="item-content">
                  <div class="bubble bubble-1">{{ $cms('c_d00c9b792a4f', 'f_0009', "跨平台多店铺难以精细化运营") }}</div>
                  <div class="bubble bubble-2">{{ $cms('c_d00c9b792a4f', 'f_0010', "线上业务没方向慢市场半拍") }}</div>
                  <div class="bubble bubble-3">{{ $cms('c_d00c9b792a4f', 'f_0011', "如何又快又准找达人") }}</div>
                  <div class="bubble bubble-4">{{ $cms('c_d00c9b792a4f', 'f_0012', "辐射达人规模有限") }}</div>
                  <img class="img1" :src="$cms('c_d00c9b792a4f', 'f_0013', &quot;https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250804185818520000751.17543050983538882.png&quot;)" alt="">
                </div>
              </div>
              <div class="item">
                <div class="item-header">
                  <!-- <img class="item-header-icon" src="https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250731171108670000660.17539530684145417.jpg" alt=""> -->
                  <div class="item-header-title">{{ $cms('c_d00c9b792a4f', 'f_0014', "达人带货") }}</div>
                </div>
                <div class="item-content">
                  <div class="bubble bubble-5">{{ $cms('c_d00c9b792a4f', 'f_0015', "钱都花哪了？") }}</div>
                  <div class="bubble bubble-6">{{ $cms('c_d00c9b792a4f', 'f_0016', "内容热点测测慢半拍") }}</div>
                  <div class="bubble bubble-7">{{ $cms('c_d00c9b792a4f', 'f_0017', "多计划并行太乱了") }}</div>
                  <div class="bubble bubble-8">{{ $cms('c_d00c9b792a4f', 'f_0018', "种草内容匮乏") }}</div>
                  <img class="img2" :src="$cms('c_d00c9b792a4f', 'f_0019', &quot;https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250813135953650000127.17550647935319482.png&quot;)" alt="">
                </div>
              </div>
            </div>
          </div>
          <div v-show="$cms('c_d00c9b792a4f', 'f_0020', true)" class="box-2">
            <div class="box-header">
              <h2 class="box-header-title">{{ $cms('c_d00c9b792a4f', 'f_0021', "魔筷星选核心服务") }}</h2>
              <div class="box-header-en-title">{{ $cms('c_d00c9b792a4f', 'f_0022', "Core Services") }}</div>
              <div class="box-header-desc">{{ $cms('c_d00c9b792a4f', 'f_0023', "赋能品牌全域增长，打造直播电商长效竞争力") }}</div>
            </div>
            <div class="box-content">
              <div class="content-planning">
                <div class="info">
                  <h2 class="title">
                    <img
:src="$cms('c_d00c9b792a4f', 'f_0024', &quot;https://mktv-in-cdn.mockuai.com/16252180739786517.png&quot;)"
                      alt=""
                      class="icon"
                    />
                    <span class="text">{{ $cms('c_d00c9b792a4f', 'f_0025', "高效拓展") }}</span>
                  </h2>
                  <div class="desc-box">
                    <div class="desc-item">
                      <h3 class="title">{{ $cms('c_d00c9b792a4f', 'f_0026', "聚焦：解决“与谁合作”和“如何长期合作”的核心问题") }}</h3>
                      <div class="desc">
                        <p>{{ $cms('c_d00c9b792a4f', 'f_0027', "✅ 自有70万+达人资源库，智能算法精准触达目标人群避免盲目投放，快速实现品牌破圈曝光") }}</p>
                        <p>{{ $cms('c_d00c9b792a4f', 'f_0028', "✅ 根据产品需求定制达人BD匹配方案，锁定高契合度达人每分预算都花在最适合推广您产品的达人身上") }}</p>
                        <p>{{ $cms('c_d00c9b792a4f', 'f_0029', "✅ 建立品牌专属达人合作关系池，长效运营，资源复用一次筛选长期生效，降低反复选人成本") }}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="main">
                  <img
:src="$cms('c_d00c9b792a4f', 'f_0030', &quot;https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250804190747040000852.17543056669221922.png&quot;)"
                    alt=""
                  />
                </div>
              </div>
              <div class="live-operation">
                <div class="info">
                  <h2 class="title">
                    <img
:src="$cms('c_d00c9b792a4f', 'f_0031', &quot;https://mktv-in-cdn.mockuai.com/16252180739563587.png&quot;)"
                      alt=""
                      class="icon"
                    />
                    <span class="text">{{ $cms('c_d00c9b792a4f', 'f_0032', "单品曝光") }}</span>
                  </h2>
                  <div class="desc-box">
                    <div class="desc-item">
                      <h3 class="title">{{ $cms('c_d00c9b792a4f', 'f_0033', "聚焦：解决“新品上市没曝光”和“爆品热度难持续”的核心问题") }}</h3>
                      <div class="desc">
                        <p>{{ $cms('c_d00c9b792a4f', 'f_0034', "✅ 引爆流量：72小时引爆单品全域曝光，曝光覆盖与销售转化双重保障") }}</p>
                        <p>{{ $cms('c_d00c9b792a4f', 'f_0035', "✅ 全域矩阵：打通抖音、快手、视频号、小红书等六大主流平台，一键分销全网带货KOL") }}</p>
                        <p>{{ $cms('c_d00c9b792a4f', 'f_0036', "✅ 热点内容：策划站内爆款内容+平台热门话题+KOL创意玩法；短视频+直播+测评笔记全网发布") }}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="main">
                  <img
:src="$cms('c_d00c9b792a4f', 'f_0037', &quot;https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250804190747040000377.17543056669235900.png&quot;)"
                    alt=""
                  />
                </div>
              </div>
              <div class="content-planning special-content">
                <div class="info">
                  <h2 class="title">
                    <img
:src="$cms('c_d00c9b792a4f', 'f_0038', &quot;https://mktv-in-cdn.mockuai.com/16252180739786517.png&quot;)"
                      alt=""
                      class="icon"
                    />
                    <span class="text">{{ $cms('c_d00c9b792a4f', 'f_0039', "专业运营") }}</span>
                  </h2>
                  <div class="desc-box">
                    <div class="desc-item">
                      <h3 class="title">{{ $cms('c_d00c9b792a4f', 'f_0040', "聚焦：解决“如何策划、执行和放大活动影响力”的核心问题") }}</h3>
                      <div class="desc">
                        <p>{{ $cms('c_d00c9b792a4f', 'f_0041', "✅ 从大促爆点、品牌大事件到跨界联名，一站式产出刷屏级活动方案避免零散策划，用体系化创意引爆话题") }}</p>
                        <p>{{ $cms('c_d00c9b792a4f', 'f_0042', "✅ 专场与品效操盘实施：经验丰富的操盘团队负责全链路高效执行（从爆品选测、话术优化到流量运营）") }}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="main">
                  <img
                    class="img2"
:src="$cms('c_d00c9b792a4f', 'f_0043', &quot;https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250804190420330000158.17543054602226770.png&quot;)"
                    alt=""
                  />
                </div>
              </div>
              <div class="live-operation">
                <div class="info">
                  <h2 class="title">
                    <img
:src="$cms('c_d00c9b792a4f', 'f_0044', &quot;https://mktv-in-cdn.mockuai.com/16252180739563587.png&quot;)"
                      alt=""
                      class="icon"
                    />
                    <span class="text">{{ $cms('c_d00c9b792a4f', 'f_0045', "智能管理") }}</span>
                  </h2>
                  <div class="desc-box">
                    <div class="desc-item">
                      <h3 class="title">{{ $cms('c_d00c9b792a4f', 'f_0046', "聚焦：解决“品牌在直播电商中如何定位、增长”的问题") }}</h3>
                      <div class="desc">
                        <p>{{ $cms('c_d00c9b792a4f', 'f_0047', "✅ 竞争赛道分析与选品策略：基于市场大盘与用户洞察，锚定品牌差异化赛道，科学规划产品矩阵与爆品梯队") }}</p>
                        <p>{{ $cms('c_d00c9b792a4f', 'f_0048', "✅ 增长目标与路径规划：结合品牌阶段目标制定清晰的GMV目标，提供可落地的执行路径。") }}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="main">
                  <img
:src="$cms('c_d00c9b792a4f', 'f_0049', &quot;https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250804190420330000484.17543054602214305.png&quot;)"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
          <div v-show="$cms('c_d00c9b792a4f', 'f_0050', true)" class="box-3">
            <div class="box-header">
              <h2 class="box-header-title">{{ $cms('c_d00c9b792a4f', 'f_0051', "合作品牌") }}</h2>
              <div class="box-header-en-title">{{ $cms('c_d00c9b792a4f', 'f_0052', "Collaborative Brand") }}</div>
              <div class="box-header-desc">{{ $cms('c_d00c9b792a4f', 'f_0053', "数千商家与品牌的共同选择") }}</div>
            </div>
            <div class="box-content">
              <div class="user-talk-list">
                <div class="user-talk-item" v-for="(item, index) in storeData" :key="index" @click="onStoreChange(index)">
                  <img
:src="$cms('c_d00c9b792a4f', 'f_0054', &quot;https://mktv-in-cdn.mockuai.com/16244409915164987.png&quot;)"
                    alt=""
                    class="play-icon"
                  />
                  <img :src="item.img" loading="lazy" alt="" class="main" />
                </div>
              </div>
              <div class="brand-info">
                <div class="title">{{ $cms('c_d00c9b792a4f', 'f_0055', "数百万商家与品牌的共同选择") }}</div>
                <div class="hot-brand-list">
                  <div class="hot-brand-item" v-for="item in hotBrandList" :key="item">
                    <img :src="item" loading="lazy" alt="">
                  </div>
                </div>
                <div class="brand-list">
                  <div class="brand-item" v-for="item in brandList" :key="item">
                    <img :src="item" loading="lazy" alt="">
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-show="$cms('c_d00c9b792a4f', 'f_0056', true)" class="box-4">
            <div class="box-header">
              <h2 class="box-header-title">{{ $cms('c_d00c9b792a4f', 'f_0057', "合作主播") }}</h2>
              <div class="box-header-en-title">{{ $cms('c_d00c9b792a4f', 'f_0058', "Collaborative Influencer") }}</div>
              <div class="box-header-desc">{{ $cms('c_d00c9b792a4f', 'f_0059', "构建70万主播矩阵分销网络，明星领衔·头部破圈·中腰渗透") }}</div>
            </div>
          </div>
          <div v-show="$cms('c_d00c9b792a4f', 'f_0060', true)" class="box-5">
            <div class="title">{{ $cms('c_d00c9b792a4f', 'f_0061', "品牌增长合作") }}</div>
            <div class="desc">{{ $cms('c_d00c9b792a4f', 'f_0062', "连接70万主播的全域流量矩阵，深度赋能品牌在不同成长阶段的品效协同增长需求") }}</div>
            <div class="btn" @click="onJoinClick(2)">{{ $cms('c_d00c9b792a4f', 'f_0063', "立即合作") }}</div>
          </div>
        </div>
      </div>
    </div>
    <video-modal
        :visible="videoModalVisible"
        :src="currentVideo"
        @close="closeVideoModal"
      ></video-modal>
  </div>
</template>

<script>
import ToolsBar from '@/components/ToolsBar.vue';
import VideoModal from "@/components/VideoModal.vue";

export default {
  components: {
    ToolsBar,
    VideoModal,
  },
  head() { return this.$cmsHead('c_d00c9b792a4f', {
    title: '商家合作-全网70万主播分销网络|直播电商解决方案|魔筷科技',
    meta: [
      {
        name: 'Keywords',
        content:
          '商家合作,主播分销,直播电商,达人带货,品牌增长,全域营销,供应链,爆款SKU,快手,抖音,视频号,小红书,魔筷科技',
      },
      {
        name: 'Description',
        content:
          '魔筷科技为品牌商家提供全网70万中小主播分销网络，沉淀各品类爆款SKU商品库，为品牌打造全域增长新引擎。提供专业的直播电商全链路解决方案，助力品牌方实现业务增长。',
      },
    ],
  }); },
  computed: {
    swiper() {
      return this.$refs.swiper.$swiper;
    },
  },
  data() {
    return {
      currentVideo: "",
      videoModalVisible: false,
      storeData: this.$cms('c_d00c9b792a4f', 'f_0064', [{"img":"https://mktv-in-cdn.mockuai.com/16391369848765571.png","video":"https://cdn.mockuai.com/tms/official_kangbahe.mp4"},{"img":"https://mktv-in-cdn.mockuai.com/16391369848784182.png","video":"https://cdn.mockuai.com/tms/official_haichijia.mp4"},{"img":"https://mktv-in-cdn.mockuai.com/16391369848825450.png","video":"https://cdn.mockuai.com/tms/official_dibolang.mp4"},{"img":"https://mktv-in-cdn.mockuai.com/16391369848948288.png","video":"https://mktv-in-cdn.mockuai.com/16267449382268738.mp4"},{"img":"https://mktv-in-cdn.mockuai.com/16391251780322593.png","video":"https://mktv-in-cdn.mockuai.com/16391061263403743.mp4"},{"img":"https://mktv-in-cdn.mockuai.com/16391251780347557.png","video":"https://mktv-in-cdn.mockuai.com/16391061263362803.mp4"}]),
      userTalkList: this.$cms('c_d00c9b792a4f', 'f_0065', ["https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250804135334860000137.17542868147556710.jpg","https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250804135334860000752.17542868147553490.jpg","https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250804135334860000552.17542868147542708.jpg","https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250804135334860000186.17542868147525590.jpg","https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250804135334860000485.17542868147506580.jpg","https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250804135334860000378.17542868147416828.jpg","https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250804135334860000100.17542868147482129.jpg","https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250804135334860000508.17542868147463968.jpg","https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250804135334860000499.17542868147448484.jpg"]),
      lecturerSwiperOption: {
        slidesPerView: 5,
        spaceBetween: "1%",
        // observer: true,
        // observeParents: true,
        navigation: {
          nextEl: ".swiper-arrow.next",
          prevEl: ".swiper-arrow.prev",
        },
        autoplay: {
          delay: 2000,
          disableOnInteraction: false,
        },
        loop: true,
      },
      lecturerSwiperData: this.$cms('c_d00c9b792a4f', 'f_0066', [{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250804143631060000146.17542893908732483.jpg","platformIcon":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250804150027250000824.17542908271319503.png","name":"球球","desc":"感觉魔筷是一个高效、有温度、服务全面的优质合作平台。"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250804143631060000146.17542893908732483.jpg","platformIcon":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250804150027250000191.17542908271279221.png","name":"滕滕包包","desc":"从籍籍无名月均不到10万的小主播，成长为单场百万级主播"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250804143631060000146.17542893908732483.jpg","platformIcon":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250804150027250000824.17542908271319503.png","name":"婉婉吖","desc":"合作初首月销售额五万，进入魔筷工作室深度合作后达成开播半小时100w"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250804143631060000146.17542893908732483.jpg","platformIcon":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250804150027250000824.17542908271319503.png","name":"婉婉吖","desc":"合作初首月销售额五万，进入魔筷工作室深度合作后达成开播半小时100w"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250804143631060000146.17542893908732483.jpg","platformIcon":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250804150027250000824.17542908271319503.png","name":"婉婉吖","desc":"合作初首月销售额五万，进入魔筷工作室深度合作后达成开播半小时100w"}]),
      hotBrandList: this.$cms('c_d00c9b792a4f', 'f_0067', ["https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250805102023680000693.17543604234963031.png","https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250805102023680000230.17543604234957957.png","https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250805102023670000394.17543604234942235.png","https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250805102023680000180.17543604234951622.png","https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250805102023680000156.17543604234935233.png","https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250805102023670000777.17543604234851827.png","https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250805103844360000226.17543615242907327.png","https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250805103844360000616.17543615242902261.png"]),
      brandList: this.$cms('c_d00c9b792a4f', 'f_0068', ["https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250829173833020000141.17564603115643762.png","https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250829173833020000472.17564603115692316.png","https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250829173833020000271.17564603115724205.png","https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250829173833020000867.17564603115773974.png","https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250829173833020000762.17564603115791077.png","https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250829173833020000380.17564603115865676.png","https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250829173833020000645.17564603115887789.png","https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250829173833040000429.17564603116134731.png","https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250829173833040000769.17564603116146367.png","https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250829173833020000193.17564603115941352.png","https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250829173833030000136.17564603115987520.png","https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250829173833020000223.17564603115965488.png","https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250829173833020000840.17564603115616842.png","https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250829173833020000399.17564603115978984.png","https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250829173833030000515.17564603115998771.png","https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250829173833030000873.17564603116041088.png","https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250829173833040000199.17564603116126020.png","https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250829173833030000106.17564603116137920.png"]),
    }
  },
  methods: {
    onJoinClick(type) {
      this.$router.push(`/apply-join?type=${type}`)
    },
    onStoreChange(index) {
      // this.currentVideo = item.video
      this.currentVideo = this.storeData[index].video;
      this.videoModalVisible = true;
    },
    closeVideoModal() {
      this.videoModalVisible = false;
    },
    onSwiperEnter() {
      this.swiper.autoplay.stop();
    },
    onSwiperLeave() {
      this.swiper.autoplay.start();
    },
  },
}
</script>

<style lang="less" scoped>
@import "../style/common.less";

.media-content {
  padding-top: 90px;
}

.service-wrapper {
  .banner-wrapper {
    left: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    .pxToVw(height, 680);
    background-color: #00092a;
    background-image: var(--cms-c_d00c9b792a4f-f_0069, url("https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250805101250300000275.17543599701789831.jpg?x-oss-process=image/quality,Q_80"));
    background-size: cover;
    background-repeat: no-repeat;
    h1.title {
      .pxToVw(margin-bottom, 13);
      line-height: 1.4;
      .pxToVw(font-size, 60);
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #fff;
    }
    .desc {
      .pxToVw(line-height, 33);
      .pxToVw(font-size, 24);
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #fff;
    }
    .actions {
      display: flex;
      align-items: center;
      .pxToVw(margin-top, 77);
      .btn {
        box-sizing: border-box;
        .pxToVw(width, 220);
        .pxToVw(height, 60);
        .pxToVw(line-height, 60);
        text-align: center;
        .pxToVw(margin-right, 40);
        border: 1px solid #fff;
        .pxToVw(border-radius, 30);
        .pxToVw(font-size, 24);
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #fff;
        cursor: pointer;
        &:last-child {
          margin-right: 0;
        }
        &:hover {
          border: none;
          background-color: #fff;
          color: #333;
        }
        &.btn-white {
          background-color: #fff;
          color: #ff6600;
          &:hover {
            background-color: #ff6600;
            color: #fff;
          }
        }
      }
    }
  }
  .content-wrapper {
    .box-header {
      .pxToVw(padding-top, 80);
      color: #333333;
      &-title {
        margin: 0 auto 8 * @unitVw;
        .pxToVw(margin-bottom, 28);
        text-align: center;
        .pxToVw(line-height, 50);
        .pxToVw(font-size, 36);
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        position: relative;
        &::after {
          content: "";
          position: absolute;
          .pxToVw(top, 64);
          left: 50%;
          .pxToVw(width, 160);
          height: 1px;
          background: #d8d8d8;
          transform: translateX(-50%);
        }
      }
      &-en-title {
        font-weight: 500;
        .pxToVw(font-size, 18);
        .pxToVw(line-height, 26);
        text-align: center;
        .pxToVw(margin-bottom, 26);
      }
      &-desc {
        text-align: center;
        .pxToVw(line-height, 25);
        .pxToVw(font-size, 18);
        font-weight: 300;
        color: #666;
      }
    }
    .box-1 {
      .pxToVw(height, 1070);
      background-image: var(--cms-c_d00c9b792a4f-f_0070, url("https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250731171108670000660.17539530684145417.jpg?x-oss-process=image/quality,Q_80"));
      background-size: 100% 100%;
      background-repeat: no-repeat;
      .box-content {
        display: flex;
        justify-content: center;
        .pxToVw(padding-top, 60);
        .pxToVw(gap, 60);
        .item {
          .pxToVw(width, 690);
          .pxToVw(height, 800);
          background: #FFFFFF;
          box-shadow: 0px 0px 30px 0px rgba(0,0,0,0.06);
          .pxToVw(border-radius, 40);
          position: relative;
          .item-header {
            display: flex;
            align-items: center;
            .pxToVw(height, 54);
            font-weight: 600;
            .pxToVw(font-size, 32);
            .pxToVw(line-height, 40);
            .pxToVw(padding-top, 42);
            .pxToVw(padding-left, 42);
            color: #333333;
          }
          .img1 {
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            .pxToVw(height, 440);
          }
          .img2 {
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            .pxToVw(height, 477);
          }
          .bubble {
            position: absolute;
            display: flex;
            align-items: center;
            .pxToVw(height, 54);
            .pxToVw(border-radius, 27);
            .pxToVw(padding-left, 20);
            .pxToVw(padding-right, 20);
            background: #FF6600;
            box-shadow: inset 0px -4px 5px 0px rgba(255,213,185,0.84);
            color: #fff;
            font-weight: 500;
            .pxToVw(font-size, 20);
            .pxToVw(line-height, 28);
            &-1 {
              .pxToVw(top, 122);
              .pxToVw(right, 30);
            }
            &-2 {
              .pxToVw(top, 197);
              .pxToVw(left, 74);
            }
            &-3 {
              .pxToVw(top, 274);
              .pxToVw(right, 40);
            }
            &-4 {
              .pxToVw(top, 303);
              .pxToVw(left, 40);
            }
            &-5 {
              .pxToVw(top, 157);
              .pxToVw(right, 97);
            }
            &-6 {
              .pxToVw(top, 199);
              .pxToVw(left, 89);
            }
            &-7 {
              .pxToVw(top, 276);
              .pxToVw(right, 61);
            }
            &-8 {
              .pxToVw(top, 320);
              .pxToVw(left, 53);
            }
          }
        }
      }
    }

    .box-2 {
      .box-content {
        .pxToVw(padding-top, 60);
      }
      .content-planning {
        position: relative;
        box-sizing: border-box;
        .pxToVw(margin-left, 120);
        .pxToVw(margin-bottom, 202);
        .pxToVw(width, 1800);
        .pxToVw(height, 680);
        .pxToVw(padding-top, 82);
        .pxToVw(padding-bottom, 92);
        border-top-left-radius: 40 * @unitVw;
        border-bottom-left-radius: 40 * @unitVw;
        background: linear-gradient(
          180deg,
          #ffffff 0%,
          rgba(255, 255, 255, 0) 100%
        );
        .info {
          .pxToVw(margin-left, 120);
          .pxToVw(width, 390);
          > .title {
            display: flex;
            align-items: center;
            .pxToVw(margin-bottom, 141);
            .icon {
              .pxToVw(width, 48);
              .pxToVw(height, 52);
              .pxToVw(margin-right, 7);
            }
            .text {
              .pxToVw(font-size, 36);
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 600;
              color: #ff6600;
            }
          }
          .desc-box {
            .desc-item {
              .pxToVw(margin-bottom, 48);
              .title {
                .pxToVw(margin-bottom, 4);
                .pxToVw(line-height, 33);
                .pxToVw(font-size, 24);
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #333333;
              }
              .desc {
                .pxToVw(font-size, 18);
                .pxToVw(line-height, 30);
                color: #666666;
                display: flex;
                flex-direction: column;
                .pxToVw(gap, 5);
              }
            }
          }
        }
        .main {
          position: absolute;
          .pxToVw(left, 569);
          .pxToVw(top, 82);
          display: flex;
          align-items: center;
          img {
            .pxToVw(border-radius, 16);
            overflow: hidden;
            &:nth-child(1) {
              .pxToVw(width, 989);
            }
            &.img2 {
              .pxToVw(width, 677);
            }
          }
        }
      }

      .special-content {
        .main {
          .pxToVw(left, 858);
        }
      }

      .live-operation {
        position: relative;
        box-sizing: border-box;
        .pxToVw(width, 1680);
        .pxToVw(height, 680);
        .pxToVw(padding-top, 80);
        .pxToVw(padding-bottom, 123);
        .pxToVw(margin-bottom, 160);
        border-top-right-radius: 40 * @unitVw;
        border-bottom-right-radius: 40 * @unitVw;
        background: linear-gradient(
          180deg,
          #ffffff 0%,
          rgba(255, 255, 255, 0) 100%
        );
        .info {
          .pxToVw(margin-left, 1020);
          > .title {
            display: flex;
            align-items: center;
            .pxToVw(margin-bottom, 116);
            .icon {
              .pxToVw(width, 50);
              .pxToVw(height, 48);
              .pxToVw(margin-right, 19);
            }
            .text {
              .pxToVw(line-height, 40);
              .pxToVw(font-size, 36);
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 600;
              color: #ff6600;
            }
          }
          .desc-box {
            .desc-item {
              .pxToVw(margin-bottom, 48);
              .pxToVw(width, 500);
              .title {
                .pxToVw(margin-bottom, 8);
                .pxToVw(line-height, 33);
                .pxToVw(font-size, 24);
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #333333;
              }
              .desc {
                .pxToVw(font-size, 18);
                .pxToVw(line-height, 30);
                color: #666666;
                display: flex;
                flex-direction: column;
                .pxToVw(gap, 5);
              }
            }
          }
        }
        .main {
          position: absolute;
          .pxToVw(left, 240);
          .pxToVw(top, 110);
          display: flex;
          align-items: center;
          img {
            display: block;
            .pxToVw(margin-right, 16);
            .pxToVw(border-radius, 16);
            overflow: hidden;
            &:nth-child(1) {
              .pxToVw(width, 677);
            }
          }
        }
      }
    }

    .box-3 {
      .user-talk-list {
        display: flex;
        flex-wrap: wrap;
        margin: 0 auto;
        .pxToVw(margin-top, 60);
        .pxToVw(margin-bottom, 80);
        .pxToVw(gap, 30);
        .pxToVw(width, 1440);
        .user-talk-item {
          position: relative;
          .pxToVw(width, 460);
          .pxToVw(height, 319);
          cursor: pointer;
          &:hover {
            .play-icon {
              visibility: visible;
            }
          }
          img.main {
            width: 100%;
            height: 100%;
          }
          .play-icon {
            visibility: hidden;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 3.658536585365854vw;
            height: 3.658536585365854vw;
          }
        }
      }
      .brand-info {
        background: #00092A;
        .title {
          .pxToVw(padding-top, 80);
          .pxToVw(padding-bottom, 60);
          .pxToVw(font-size, 36);
          .pxToVw(line-height, 50);
          font-weight: 600;
          color: #FFFFFF;
          text-align: center;
        }
      }
      .hot-brand-list {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        .pxToVw(gap, 40);
        .pxToVw(padding-bottom, 60);
        .hot-brand-item {
          .pxToVw(width, 700);
          .pxToVw(height, 400);
          img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }
      .brand-list {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        margin: 0 auto;
        .pxToVw(width, 1440);
        .pxToVw(gap, 35);
        .pxToVw(padding-bottom, 60);
        .brand-item {
          .pxToVw(width, 126);
          .pxToVw(height, 126);
          img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }
    }

    .box-4 {
      width: 100%;
      .pxToVw(height, 1000);
      background-image: var(--cms-c_d00c9b792a4f-f_0071, url("https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250815133926250000715.17552363660396127.jpg?x-oss-process=image/quality,Q_80"));
      background-size: cover;
      background-repeat: no-repeat;
      position: relative;
      .box-header {
        color: #fff;
        &-desc {
          color: #fff;
        }
      }
    }

    .box-5 {
      .pxToVw(width, 1440);
      .pxToVw(height, 500);
      .pxToVw(margin-top, 80);
      .pxToVw(margin-bottom, 60);
      .pxToVw(border-radius, 16);
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background: #00092A;
      .title {
        .pxToVw(font-size, 60);
        .pxToVw(line-height, 84);
        font-weight: 500;
        color: #FFFFFF;
      }
      .desc {
        .pxToVw(font-size, 24);
        .pxToVw(line-height, 36);
        .pxToVw(margin-top, 20);
        .pxToVw(margin-bottom, 60);
        font-weight: 300;
        color: #FFFFFF;
      }
      .btn {
        box-sizing: border-box;
        .pxToVw(width, 220);
        .pxToVw(height, 60);
        .pxToVw(line-height, 60);
        text-align: center;
        .pxToVw(margin-right, 40);
        border: 1px solid #fff;
        .pxToVw(border-radius, 30);
        .pxToVw(font-size, 24);
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #fff;
        cursor: pointer;
        background-color: #fff;
        color: #ff6600;
        &:hover {
          background-color: #ff6600;
          color: #fff;
        }
      }
    }
  }
}
</style>
